<template>
  <v-dialog
    :value="value"
    @input="(v) => $emit('input', value)"
    persistent
    :overlay="false"
    max-width="500px"
    transition="dialog-transition"
  >
    <v-card color="neutral700">
      <SizeBox height="8" />
      <div class="d-flex justify-end">
        <v-avatar
          size="24"
          @click="$emit('input', false)"
          class="cursor-pointer"
        >
          <img :src="require(`@/assets/icons/close.svg`)" />
        </v-avatar>
        <SizeBox width="8" />
      </div>
      <v-card-title class="flex-center pt-1">
        {{ $t('AUTH.COPYWRITING.RE_SEND_VERIFICATION_EMAIL') }}
      </v-card-title>
      <v-card-text class="text-center text-pre-wrap"></v-card-text>
      <v-card-actions class="flex-center">
        <v-btn outlined width="120" @click="$emit('input', false)">
          {{ $t('COMMON.WORD.CANCEL') }}
        </v-btn>
        <SizeBox width="16" />
        <v-btn
          width="120"
          depressed
          color="primary"
          @click="$emit('do-resend')"
        >
          {{ $t('COMMON.WORD.CONFIRM') }}
        </v-btn>
      </v-card-actions>
      <SizeBox height="18" />
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style lang="scss" scoped>
//
</style>